// plan-19 S06: divine post → canvas text renderer for exportCard

import type { GeneratedPost } from './generate'
import type { ContentRegion } from '../../core/exportCard'
import { wrapText } from '../../core/exportCard'

const COLOR_GREEN_DIM = '#005A00'
const COLOR_KING_GREEN = '#00B400'
const COLOR_TERM_GREEN = '#00D200'

const FONT_FAMILY = '"IBM Plex Mono", monospace'

export function renderDivineContent(
  post: GeneratedPost,
): (ctx: CanvasRenderingContext2D, region: ContentRegion) => void {
  return (ctx, region) => {
    ctx.textAlign = 'left'
    ctx.textBaseline = 'alphabetic'

    const lineH = 40
    const labelH = 32
    let y = region.y + lineH
    const x = region.x
    const maxW = region.w

    // @network — dim label
    ctx.font = `16px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_GREEN_DIM
    ctx.fillText('@network', x, y)
    y += labelH

    // > sentence — term-green, may wrap
    ctx.font = `22px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_TERM_GREEN
    y = wrapText(ctx, `> ${post.sentence}`, x, y, maxW, lineH)

    // > probablyTag — term-green
    y = wrapText(ctx, `> ${post.probablyTag}`, x, y, maxW, lineH)

    // separator (small gap)
    y += lineH * 0.5

    // metadata block — dim, 18px, tighter line height
    ctx.font = `18px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_GREEN_DIM
    const metaH = 32
    y = wrapText(ctx, `@quorum: ${post.quorumTag}.`, x, y, maxW, metaH)
    y = wrapText(ctx, `@certainty: ${post.certainty} remaining.`, x, y, maxW, metaH)
    y = wrapText(ctx, `@verdict: ${post.verdictText}.`, x, y, maxW, metaH)
    y = wrapText(ctx, `@hash: ${post.hash}`, x, y, maxW, metaH)

    void COLOR_KING_GREEN
  }
}
